import React from 'react'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import { Typography, Box } from '@mui/material'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome'
import SpeedIcon from '@mui/icons-material/Speed'
import SecurityIcon from '@mui/icons-material/Security'
import { useApplicationSuiteContext } from '../../../contexts/ApplicationSuiteProvider'
import { getMemberPortalUrl } from '../../../common/utils/memberPortalUrl'

interface AutotraderUpgradeDialogProps {
  open: boolean
  onClose: () => void
}

const AutotraderUpgradeDialog: React.FC<AutotraderUpgradeDialogProps> = ({ open, onClose }) => {
  const { tradingHouse } = useApplicationSuiteContext()

  const handleClose = () => {
    onClose && onClose()
  }

  function openMarketplace() {
    window.open(
      getMemberPortalUrl(tradingHouse, '/dashboard/marketplace?display=autotrader'),
      '_blank'
    )
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle textAlign={'center'}>
        Unlock
        <Typography variant={'h6'} color={'primary'} display={'inline'}>
          {' '}
          Auto Trading{' '}
        </Typography>
        with Strategy Suite
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Box display={'flex'} flexDirection={'column'} py={2} gap={2}>
            <Box display={'flex'} alignItems={'center'} gap={1}>
              <AttachMoneyIcon fontSize={'large'} color="primary" />
              <Box>
                <Typography variant={'body1'} color={'textPrimary'} fontWeight={'bold'}>
                  Automated Trading:
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Execute trades automatically when your pattern rules are met.
                </Typography>
              </Box>
            </Box>

            <Box display={'flex'} alignItems={'center'} gap={1}>
              <SpeedIcon fontSize={'large'} color="primary" />
              <Box>
                <Typography variant={'body1'} color={'textPrimary'} fontWeight={'bold'}>
                  Lightning Fast Execution:
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Never miss an opportunity with instant trade execution.
                </Typography>
              </Box>
            </Box>

            <Box display={'flex'} alignItems={'center'} gap={1}>
              <AutoAwesomeIcon fontSize={'large'} color="primary" />
              <Box>
                <Typography variant={'body1'} color={'textPrimary'} fontWeight={'bold'}>
                  24/7 Monitoring:
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Your strategies work around the clock, even when you're not watching.
                </Typography>
              </Box>
            </Box>

            <Box display={'flex'} alignItems={'center'} gap={1}>
              <SecurityIcon fontSize={'large'} color="primary" />
              <Box>
                <Typography variant={'body1'} color={'textPrimary'} fontWeight={'bold'}>
                  Risk Management:
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Built-in safety controls and position sizing for responsible trading.
                </Typography>
              </Box>
            </Box>
          </Box>

          <Box mt={2} p={2} sx={{ backgroundColor: 'action.hover', borderRadius: 1 }}>
            <Typography
              variant={'body1'}
              color={'textPrimary'}
              fontWeight={'bold'}
              textAlign={'center'}
            >
              Take your trading to the next level with automated execution
            </Typography>
          </Box>
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '16px',
        }}
      >
        <Button onClick={handleClose} color="primary">
          Maybe Later
        </Button>
        <Button onClick={openMarketplace} variant={'contained'} color={'primary'}>
          Upgrade to Auto Trading
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default AutotraderUpgradeDialog
